import o from "../../../helpers/service-helper.js";
import "react/jsx-runtime";
import "dayjs";
const l = async ({ locationId: e, typeId: t, pickupTime: r, returnTime: i }) => {
  const n = {
    "Content-Type": "application/json"
  };
  return o.httpGet(
    `/v1/rentaltrailer/price?LocationId=${e}&TypeId=${t}&PickupTime=${r}&ReturnTime=${i}`,
    { headers: n }
  );
};
export {
  l as getTrailerRentalPrice
};
